<template>
  <browse-filter>
    <browse-filter-checkbox
      label="Black Friday"
      value="black-friday"
      :checked="value"
      @click="select"
    >
      <template #label>
        <img
          class="logo"
          :src="BlackFridayLogo"
          alt="Black Friday"
        >
      </template>
      <img
        v-popover:filter-bf.bottom
        :src="QuestionMark"
        alt="About"
        class="question"
      >
      <client-only>
        <v-popover
          class="popover"
          name="filter-bf"
          event="hover"
          :width="300"
        >
          Show Black Friday eligible tools only.
          Add $150+ of these tools to your cart to unlock 10% off.
        </v-popover>
      </client-only>
    </browse-filter-checkbox>
  </browse-filter>
</template>
<script>
import QuestionMark from '~/static/question-mark.svg';
import BlackFridayLogo from '~/static/blackfriday.svg';
import BrowseFilter from './BrowseFilter.vue';
import BrowseFilterCheckbox from './BrowseFilterCheckbox.vue';

export default {
  components: {
    BrowseFilter,
    BrowseFilterCheckbox,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      BlackFridayLogo,
      QuestionMark,
    };
  },
  methods: {
    select(event) {
      this.$emit('input', event.target.checked);
    },
  },
};
</script>
<style scoped>
em {
  font-style: normal;
  font-size: 12px;
}

.logo {
  height: 24px;
  vertical-align: middle;
}

.question {
  cursor: pointer;
}
</style>
